<template>
  <div class="body">
    <div class="title">
      <h3>List of users</h3>
      <label for="time" class="font_reg" style="margin: 0 0 0 50px">Time</label>
      <select
        id="view-date"
        name="time"
        @change="handleTimeSelection"
        v-model="timePeriodModel"
      >
        <option value="total">total</option>
        <option value="week">week</option>
        <option value="month">month</option>
        <option value="year">year</option>
      </select>
    </div>
    <div class="box">
      <div id="Users-box">
        <table class="table">
          <thead>
            <tr>
              <th scope="col">Number</th>
              <th scope="col">Nickname</th>
              <th scope="col">Games</th>
              <th scope="col">Total time of use</th>
              <th scope="col">Avg use time</th>
              <th scope="col">Strongest</th>
              <th scope="col">Sport</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="getUsersOverview.data.length == 0">
              <td>No data for the selected period</td>
            </tr>
            <tr
              v-else
              v-for="(user, id) in getUsersOverview.data"
              :key="user.id"
            >
              <td>{{ id + rowNumber }}</td>
              <td>{{ user.username }}</td>
              <td>{{ user.selected }}</td>
              <td>{{ getFormattedTime(user.total_time_of_use) }}</td>
              <td>{{ getAverageFormattedTime(user.average_use_time) }}</td>
              <td>{{ getUserStrongest(user) }}</td>
              <td>{{ user.category_name }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <PaginationNavigation
        @onNext="onNextPage"
        @onPrev="onPrevPage"
        :page="pageNumber"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { GET_USER_OVERVIEW } from "../../store/actions.type";
import getFormattedTime from "../../mixins/formatTime";
import getAverageFormattedTime from "../../mixins/formatTime";
import PaginationNavigation from "../PaginationNavigation.vue";
import prevPage from "../../mixins/pagination";
import nextPage from "../../mixins/pagination";
export default {
  mixins: [getFormattedTime, getAverageFormattedTime, prevPage, nextPage],
  name: "sdcs",
  data() {
    return {
      timePeriodModel: "week",
      usersByDate: [],
      allItems: [],
      id: 0,
      pageNumber: 1,
      rowNumber: 1
    };
  },
  watch: {
    timePeriodModel() {},

    getSelectedCourt() {
      this.$store.dispatch(GET_USER_OVERVIEW, {
        courtId: this.getSelectedCourt.id,
        time: this.timePeriodModel,
        page: this.pageNumber
      });
    }
  },
  computed: {
    ...mapGetters([
      "getSkillgameLogs",
      "takeAllUsers",
      "getUsersOverview",
      "getSelectedCourt"
    ])
  },
  methods: {
    async onNextPage() {
      this.pageNumber = this.nextPage(
        this.pageNumber,
        this.getSelectedCourt.id,
        this.timePeriodModel
      );

      await this.$store.dispatch(GET_USER_OVERVIEW, {
        courtId: this.getSelectedCourt.id,
        time: this.timePeriodModel,
        page: this.pageNumber
      });
      if (this.getUsersOverview.from) {
        this.rowNumber = this.getUsersOverview.from;
      }
    },
    async onPrevPage() {
      this.pageNumber = this.prevPage(this.pageNumber);
      await this.$store.dispatch(GET_USER_OVERVIEW, {
        courtId: this.getSelectedCourt.id,
        time: this.timePeriodModel,
        page: this.pageNumber
      });

      this.rowNumber = this.getUsersOverview.from;
    },
    handleTimeSelection() {
      this.pageNumber = 1;
      this.rowNumber = 1;

      this.$store.dispatch(GET_USER_OVERVIEW, {
        courtId: this.getSelectedCourt.id,
        time: this.timePeriodModel,
        page: this.pageNumber
      });
    },
    getUserStrongest(user) {
      const abilities = [
        user.ability_speed,
        user.ability_endurance,
        user.ability_dribbling,
        user.ability_passing,
        user.ability_agility,
        user.ability_reaction
      ];
      const highest = Math.max(...abilities);
      if (highest === Math.min(...abilities)) {
        return "None";
      }
      switch (highest) {
        case user.ability_speed:
          return "Speed";
        case user.ability_agility:
          return "Agility";
        case user.ability_endurance:
          return "Endurance";
        case user.ability_dribbling:
          return "Dribbling";
        case user.ability_reaction:
          return "Reaction";
        case user.ability_passing:
          return "Passing";
      }
    }
  },
  components: { PaginationNavigation },
  mounted() {
    this.$store.dispatch(GET_USER_OVERVIEW, {
      courtId: this.getSelectedCourt.id,
      time: this.timePeriodModel,
      page: this.pageNumber
    });
  }
};
</script>

<style scoped>
.box {
  margin: 0;
  width: 100%;
  height: 631px;
  padding-top: 40px;
}
.title * {
  margin: 50px 0px 16px 0px;
}
#view-date {
  margin: 0 70px 0 5px;
}
.font_reg {
  font-family: Montserrat-Regular;
}

#Users-box {
  width: 100%;
  height: 520px;
  background-color: #383838;
  /* style="overflow-y:auto;" */
  overflow-y: auto;
}
tbody {
  width: 1100px;
  height: 520px;
}
.table {
  border-collapse: collapse;
  width: 100%;
  height: 520px;
}
th {
  opacity: 1;
  position: sticky;
  top: 0;
  background-color: #383838;
  font-size: 14px;
  font-family: Montserrat-Medium;
  font-weight: normal;
  color: rgba(255, 255, 255, 0.7);
}
th,
td {
  /* padding: 8px; */
  text-align: left;
  border-bottom: 1px solid #505050;
  background-color: #383838;
  text-align: center;
}
td {
  padding: 16px;
  /* height: 51; */
  /* margin-top:54px ; */
  /* padding: 0; */
}
tr {
  font-family: Montserrat-SemiBold;
  font-size: 16px;
  font-weight: normal;
  padding-top: 25px;
}

select {
  direction: rtl;
  /* text-align: justify !important; */
  text-align: center !important;
  text-indent: 0%;
}
option {
  direction: ltr !important;
  text-align: left;
}
.search_input::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: white;
  opacity: 1; /* Firefox */
}

/* width */
::-webkit-scrollbar {
  width: 6px;
  border-left: 1px solid #e6ecf8;
}
/* Track */
::-webkit-scrollbar-track {
  background: #383838;
  height: 100px;
}
::-webkit-scrollbar-thumb {
  height: 10px;
  border: solid 3px #707070;
  border-radius: 20px;
  padding: 20px;
}
/* Handle on hover   doesn't work */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>
